import CheckIcon from '@mui/icons-material/Check';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import settings from '/@/core/settings';
import colors from '../../theme-provider/colors';

const TechnologyButtons = ({
    setTechnology,
    technology,
    isMobile,
    crop,
}: {
    setTechnology: (technology: string) => void;
    technology: string;
    isMobile: boolean;
    crop: string;
}) => {
    if (crop !== 'corn') return null;
    return (
        <Grid
            item
            container
            xs={isMobile ? 6 : 2}
            justifyContent={isMobile ? 'center' : 'end'}
            spacing={1}
            flexWrap='nowrap'
        >
            {['VTPRO3', 'VTPRO4'].map((tech) => (
                <Grid item>
                    <Button
                        size='small'
                        onClick={() => {
                            setTechnology(tech);
                        }}
                        variant='outlined'
                        color='primary'
                        sx={
                            technology === tech && {
                                borderColor: colors.themes[settings.app.theme].primary.default,
                            }
                        }
                    >
                        <Stack direction='row' alignItems='center' gap={1}>
                            <Typography
                                sx={{
                                    color:
                                        technology === tech
                                            ? colors.themes[settings.app.theme].primary.default
                                            : 'white',
                                }}
                                variant='body2'
                            >
                                {tech}
                            </Typography>

                            {technology === tech && (
                                <CheckIcon
                                    sx={{
                                        display: technology === tech ? 'block' : 'none',
                                        color:
                                            technology === tech
                                                ? colors.themes[settings.app.theme].primary.default
                                                : colors.gray[800],
                                    }}
                                />
                            )}
                        </Stack>
                    </Button>
                </Grid>
            ))}
        </Grid>
    );
};

export default TechnologyButtons;
